/* oxlint-disable typescript/no-explicit-any */
import { pickBy, isNil } from 'ramda';

import { NonNullableProperties } from './types';

//TODO типизация не полностью верна, пустая строка не фильтруется, способа исправить не нашел
export const pickOnlyMeaning = <T extends { [key: string]: any }>(a: T): NonNullableProperties<T> =>
  pickBy(v => !isNil(v) && v !== '', a);
